<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img
              src="https://sirv.sirv.com/website/theme2/icon/question.svg"
              :alt="hint"
            >
          </div>
          <div
            v-show="showHint"
            class="hint"
          >
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{disabled: !status}"
          @click="status =! status"
        />
        <el-radio
          v-for="(radioValue, index) in radioOption"
          :key="index"
          v-model="value"
          :disabled="!status"
          :label="radioValue.value"
          @change="changeOption"
        >
          {{ radioValue.value === 'start' ? 'Beginning' : 'End' }}
        </el-radio>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'RadioInputCustom',
  props: {
    title: {
      type: String,
      default: ''
    },
    default: {
      type: [Boolean, String]
    },
    hint: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean
    },
    options: {
      type: Array,
      default: () => []
    },
    selectValue:{
      type: [String, Number],
    },
    eventClick: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      value: this.default,
      radioOption: this.options,
      showHint: false
    }
  },
  computed: {
    ...mapState([
      'clearOptions',
      'settings',
      'zoomEnable'
    ]),
    smv(){
      return this.settings.smv
    }
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.value = this.default
      }
    },
    eventClick(val) {
      this.value = this.default
    },

    selectValue(){
      this.changeOption()
    }
  },
  methods: {
    ...mapMutations(['CHANGE_SVM']),
    changeOption () {
      if( this.status && this.selectValue && this.smv.length ) {
        const value = [...this.smv]
        value[this.selectValue - 1].pined = this.value
        this.CHANGE_SVM(value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep{

  &.control{
    margin-top: 10px;
  }

  &.control__choice,
  &.control__title{
    margin-left: 0;
  }
}

</style>
